"use strict";

var Toast = function () {

  var handleToast = function (data) {
    if (!toastr) {
      return;
    }
    var data = JSON.parse(data);
    toastr.options.closeButton = true;
    if (data.success) {
      toastr.success(data.success);
    }
    if (data.warning) {
      toastr.warning(data.warning);
    }
    if (data.info) {
      toastr.info(data.info);
    }
    if (data.danger) {
      toastr.error(data.danger);
    }
  };

  return {
    init: function(data) {
      handleToast(data);
    }
  };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Toast;
}